export const UserCategory = {
  // Global admin is the highest level of user, with all permissions
  GLOBAL_ADMIN: "globalAdmin",
  MANAGER_ID: "managerId",
  OWNER: "owner",
  ADMIN: "administrator",
  MODERATOR: "moderator",
  READER: "reader",
  NORMAL: "normal", // lowest
};

const RolePriority = [
  UserCategory.GLOBAL_ADMIN,
  UserCategory.MANAGER_ID,
  UserCategory.OWNER,
  UserCategory.ADMIN,
  UserCategory.MODERATOR,
  UserCategory.READER,
  UserCategory.NORMAL,
];

export const GroupTabs = {
  DETAILS: "details",
  MEMBERS: "members",
  MODERATORS_AND_READERS: "moderatorsAndReaders",
  GROUP_ROLE_ASSIGNMENTS: "groupRoleAssignments",
  GROUP_TREE_VIEW: "groupTreeView",
  SYNCHRONIZATION: "synchronization",
  AUDIT: "audit",
  EMAIL_PROPERTIES: "emailProperties",
  CRITERIA: "criteria",
  GROUP_FLATTENED_MEMBERS: "flattenedGroupMembership",
};

const Tabs = [
  GroupTabs.DETAILS,
  GroupTabs.MEMBERS,
  GroupTabs.MODERATORS_AND_READERS,
  GroupTabs.GROUP_ROLE_ASSIGNMENTS,
  GroupTabs.GROUP_TREE_VIEW,
  GroupTabs.SYNCHRONIZATION,
  GroupTabs.AUDIT,
  GroupTabs.EMAIL_PROPERTIES,
  GroupTabs.CRITERIA,
  GroupTabs.GROUP_FLATTENED_MEMBERS,
];

function rw(read, write) {
  return { read, write };
}

export function userCanRead(category, tab) {
  return permissionMap[category]?.[tab]?.read || false;
}

export function userCanWrite(category, tab, hasGroupManagerId = false) {
  if (hasGroupManagerId) return false; // Means the group is managed by another entity
  if (category === UserCategory.GLOBAL_ADMIN) return true;
  return permissionMap[category]?.[tab]?.write || false;
}

export function userCanReadGroupDetails(category) {
  return userCanRead(category, GroupTabs.DETAILS);
}

function allTabsAccess(read, write) {
  const access = {};
  Tabs.forEach((tab) => {
    access[tab] = rw(read, write);
  });
  return access;
}

export function resolveUserCategory(roles) {
  if (!Array.isArray(roles)) return "normal";
  for (const role of RolePriority) {
    if (roles.includes(role)) {
      return role;
    }
  }
  return "normal";
}

const permissionMap = {
  [UserCategory.GLOBAL_ADMIN]: allTabsAccess(true, true),
  [UserCategory.OWNER]: allTabsAccess(true, true),
  [UserCategory.ADMIN]: allTabsAccess(true, true),

  [UserCategory.MODERATOR]: {
    details: rw(true, true),
    members: rw(true, true),
    moderatorsAndReaders: rw(true, true),
    groupRoleAssignments: rw(true, true),
    groupTreeView: rw(true, true),
    flattenedGroupMembership: rw(true, true),
    synchronization: rw(true, true),
    audit: rw(false, false),
    emailProperties: rw(true, true),
    criteria: rw(true, true),
  },

  [UserCategory.READER]: {
    details: rw(true, false),
    members: rw(true, false),
    moderatorsAndReaders: rw(true, false),
    groupRoleAssignments: rw(true, false),
    groupTreeView: rw(true, false),
    flattenedGroupMembership: rw(true, false),
    synchronization: rw(true, false),
    audit: rw(false, false),
    emailProperties: rw(true, false),
    criteria: rw(true, false),
  },

  [UserCategory.NORMAL]: {
    details: rw(true, false),
    members: rw(true, false),
    moderatorsAndReaders: rw(false, false),
    groupRoleAssignments: rw(false, false),
    groupTreeView: rw(false, false),
    flattenedGroupMembership: rw(false, false),
    synchronization: rw(false, false),
    audit: rw(false, false),
    emailProperties: rw(true, false),
    criteria: rw(false, false),
  },
};
